import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { NavLink } from 'react-router';

import CheckRequirements from '@/components/CheckRequirements';

import useStyles from './SidebarSubmenuPopup.styles';
import type { SidebarButtonProps } from './SidebarSubmenuPopup.types';

function SidebarSubmenuPopup(props: SidebarButtonProps) {
  const { anchorEl, handleInternalMenu, isSubmenuExpanded, item } = props;
  const { classes } = useStyles();

  const id = isSubmenuExpanded.Internal ? 'internal-menu-popover' : undefined;

  return (
    <Popover
      id={id}
      open={isSubmenuExpanded?.Internal}
      anchorEl={anchorEl}
      onClose={handleInternalMenu}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <div className={`${classes.submenuPopup} submenu`}>
        <Typography className={classes.submenuPopupHeader} component="span">
          {item.label.toUpperCase()}
        </Typography>
        <List sx={{ pt: '0.75rem' }} disablePadding>
          {item.menu?.map((subItem) => (
            <CheckRequirements
              key={subItem.label}
              permissions={subItem.permissions}
            >
              <ListItem
                disablePadding
                key={subItem.label}
                onClick={(e) => {
                  handleInternalMenu(e);
                }}
              >
                <NavLink
                  key={subItem.label}
                  aria-label={subItem.ariaLabel}
                  className={classes.submenuPopupNavLink}
                  to={subItem.pathTo}
                >
                  <ListItemButton
                    className={classes.submenuPopupButton}
                    key={subItem.label}
                  >
                    <ListItemText
                      className={classes.submenuPopupText}
                      primary={subItem.label}
                    />
                  </ListItemButton>
                </NavLink>
              </ListItem>
            </CheckRequirements>
          ))}
        </List>
      </div>
    </Popover>
  );
}

export default SidebarSubmenuPopup;
